import { Grid, InputAdornment, TextField } from '@mui/material';
import { LocalizationProvider, MobileDateTimePicker } from '@mui/x-date-pickers';
import DateRangeIcon from '@mui/icons-material/DateRange';
import React from 'react';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

const StartTime = (props: any) => {
    const [val, setVal] = React.useState(new Date(props.time));
    const [myMargin, setMyMargin] = React.useState(props.myMargin);

    React.useEffect(() => {
        setMyMargin(props.myMargin);
        console.log(props.myMargin);
    }, [props.myMargin]);

    const handleValueChange = (newValue: Date | null) => {
        console.log('NEW: ', newValue);
        if (newValue) {
            console.log('IF');
            setVal(newValue);
            props.onChange(newValue);
            console.log(props.onChange);
        }
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <MobileDateTimePicker
                value={val}
                onChange={(newValue) => {
                    handleValueChange(newValue);
                }}
                label={props.timeLabel}
                onError={console.log}
                minDate={new Date('2018-01-01T00:00')}
                inputFormat="yyyy/MM/dd hh:mm a"
                mask="___/__/__ __:__ _M"
                renderInput={(params) => (
                    <TextField
                        {...params}
                        fullWidth
                        margin={myMargin}
                        error={false}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <DateRangeIcon />
                                </InputAdornment>
                            )
                        }}
                    />
                )}
            />
        </LocalizationProvider>
    );
};

export default StartTime;
